import { MS_IN_DAY } from '../../global/constants/date'

function getISOWeekNumberFromDate(date: Date): number {
  // Create a copy of the date to avoid modifying the input
  const targetDate = new Date(date)

  // Set to midnight to avoid time issues
  targetDate.setHours(0, 0, 0, 0)

  // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  // Convert to ISO weekday where 1 = Monday, ..., 7 = Sunday
  const dayOfWeek = targetDate.getDay() || 7

  // Set targetDate to the Thursday in the current week
  // This is important because the ISO week containing Jan 4 is always week 1
  targetDate.setDate(targetDate.getDate() + (4 - dayOfWeek))

  // Store the January 1st of the targetDate's year
  const yearStart = new Date(targetDate.getFullYear(), 0, 1)

  // Calculate the ISO week number
  // We add 1 because counting starts at 1, not 0
  const weekNumber = Math.ceil(
    ((targetDate.getTime() - yearStart.getTime()) / MS_IN_DAY + 1) / 7,
  )

  return weekNumber
}

export default getISOWeekNumberFromDate
